import { currentPage } from '../common/layout';
import {
  disableAdsInEmbedVideo,
  openCommentsDrawer,
  coralCommentsEdition,
  checkAndFilterCoralCommentsAmountToShow,
  getAdfeed,
  getCookie,
  setCookie,
  exportGallery,
} from '../common/utils/fn';
import { initCoralComments } from '../common/comments/comments';
import { getStroeerGalleryBanners } from '../common/utils/adv-stroeer-mobile-gallery-loader';
import { getFaqWidget } from '../common/widgets/widget-faq-loader';
import { getCompareImages } from '../common/widgets/widget-compare-images-loader';
import { getPointsOfInterest } from '../common/widgets/widget-points-of-interest-loader';
import { getStickyVideo } from '../common/utils/sticky-video-loader';
import { topComments } from '@top-comments';
import device from 'current-device';

currentPage.pageInit = ($page, pageData, pageId) => {
  const dataEdtn = document.body.dataset.edtn;
  // const urlGetParam = window.location.search;
  // const isAutoPlay = urlGetParam == '?autoplayEmbed' ? true : false;

  var $window = $(window),
    $body = $(document.body),
    $page = $('#' + pageId),
    $recommendedBox = $page.find('.recommendedBox'),
    $pageIsRtl = $('body').data('rtl');
  var isVideoArticle = document.querySelector('.videowrapper');
  let hasVideoWidget = document.querySelector('[data-widget="video"]');
  let hasZypeWidget = document.querySelector('[data-widget="video_zype"]');
  let cpUserIsLogged = $body.hasClass('cpauthenticated');
  // cpass
  const $contentpassEditions = ['fr', 'ar', 'us', 'it', 'me', 'es', 'tr', 'id'];
  var cpAuthhint = document.cookie.includes('_cpauthhint=1');
  let isDevEnv = document.body.classList.contains('development');
  const hasPhotoGallery = document.querySelector('.msnt-photo-thumb-gallery');
  const hasImageWidget = document.querySelector('section[data-widget="image"]');

  import(/* webpackPrefetch: true */ '../common/scroll-depth').then(
    (module) => {
      module.trackSectionScrollDepth($('article'));
    },
  );

  // cpass
  if (!cpAuthhint) {
    disableAdsInEmbedVideo();
  }

  checkAndFilterCoralCommentsAmountToShow();
  // cpass

  if (!cpAuthhint) {
    topComments.init({
      config: { active: 1 },
    });
  }

  window.msntConsent.initEmbeds($('.postBody'));
  // cpass
  if (cpAuthhint) {
    window.msntConsent.initEmbedVideo($('.root'));
  }

  const shareData = {
    title: document.getElementsByClassName('main-article-heading')[0]
      .textContent,
    text: document.getElementsByClassName('sub-article-heading')[0].textContent,
    url: document.location.href,
  };

  let shareButton = document.getElementsByClassName('m1-article-meta_share')[0];
  // console.log(shareButton, window.device.type);
  if (shareButton !== null) {
    shareButton.addEventListener('click', async () => {
      if (window.device.type !== 'desktop') {
        gtmDataLayer.push({
          event: 'socialButtonClicked',
        });
        try {
          await navigator.share(shareData);
        } catch (err) {
          console.log(err);
        }
      }
    });
  }

  window.addEventListener('message', function (e) {
    let data = e.data;
    if (data === 'newComment') {
      gtmDataLayer.push({
        event: data,
      });
    }
  });

  // scrollingToComments();
  let pointsOfInterestWidget = document.querySelector(
    '[data-widget="points-of-interest"]',
  );
  if (pointsOfInterestWidget) {
    getPointsOfInterest().then((api) => {
      api.pointsOfInterest();
    });
  }

  let compareImagesWrapper = document.querySelector(
    '[data-widget="compare-images"]',
  );
  if (compareImagesWrapper) {
    getCompareImages().then((api) => {
      api.compareImages();
    });
  }

  let faqWidget = document.querySelector('.widget_faq');
  if (faqWidget) {
    getFaqWidget().then((api) => {
      api.faqAccordeon();
    });
  }

  let facebookWrapper = document.getElementsByClassName(
    'facebook-video-wrapper',
  )[0];

  if (facebookWrapper) {
    (() => {
      let fbSizer = facebookWrapper.querySelector('.sizer');
      let videoIframe = facebookWrapper.querySelector('iframe');

      let fbSizerHeight = fbSizer.offsetHeight;
      let videoIframeWidth = videoIframe.getAttribute('width');
      let videoIframeHeight = videoIframe.getAttribute('height');
      let iframeAspectRatio = videoIframeHeight / videoIframeWidth;

      if (iframeAspectRatio === 1) {
        videoIframe.height = fbSizerHeight;
        videoIframe.width = fbSizerHeight;
      } else if (iframeAspectRatio === 0.5625) {
        facebookWrapper.classList.add('facebook-iframe-sizer');
      } else if (iframeAspectRatio > 1) {
        videoIframe.height = fbSizerHeight;
        videoIframe.width = fbSizerHeight / iframeAspectRatio;
      } else {
        videoIframe.height = fbSizerHeight;
        facebookWrapper.classList.add('facebook-iframe-sizer');
      }
    })();
  }

  if (
    isVideoArticle != null ||
    hasVideoWidget instanceof Element ||
    hasZypeWidget instanceof Element
  ) {
    getStickyVideo().then((api) => {
      api.stickyVideo(dataEdtn, false);
    });
  }

  // let collectedVideoEmbeds = document.querySelectorAll('.videoplayer');
  // if (collectedVideoEmbeds.length > 0) {
  //   getPlayVideoEmbed().then((api) => {
  //     api.playVideoEmbed(collectedVideoEmbeds);
  //   });
  // }

  if (dataEdtn == 'de' || (dataEdtn == 'ev_de' && !cpAuthhint)) {
    getStroeerGalleryBanners().then((api) => {
      api.initDeMobileGalleryBanners();
    });
  }

  let lightzoomWidget = document.querySelector('.lightzoom');
  if (lightzoomWidget && device.type !== 'mobile') {
    import(/* webpackPrefetch: true */ '../common/lightzoom-loader').then(
      (module) => {
        module.initializeLightzoom();
      },
    );
  } else if (lightzoomWidget && device.type == 'mobile') {
    let lightzoomWidgets = document.querySelectorAll('.lightzoom');
    for (let lightzoomWidgetItem of lightzoomWidgets) {
      lightzoomWidgetItem.addEventListener('click', (e) => {
        e.preventDefault();
        return;
      });
    }
  }

  if (hasPhotoGallery || hasImageWidget) {
    const galleryReady = import(
      /* webpackPrefetch: true */ '../common/msnt/msnt-photo-thumb-gallery'
    )
      .then((module) => {
        module.msntPhotoThumbGallery();
      })
      .catch((err) => {
        console.error(err);
      });

    document.addEventListener('click', (event) => {
      const target = event.target.closest(
        '.lslide, section[data-widget="image"][data-id], .msnt-photo-thumb-gallery-main-photo-box',
      );

      if (!target) return;

      event.preventDefault();

      galleryReady.then(() => {
        exportGallery({
          preventDefault: () => {},
          currentTarget: target,
        });
      });
    });
  }

  const coralContainer = $('#coral_thread_app');
  //this is a new realization of comments staff
  if (coralCommentsEdition.includes(dataEdtn)) {
    const commentButtons = document.querySelectorAll(
      '.m1-article-meta_comments',
    );
    let coralCommentsLoaded = false;

    for (let commentButton of commentButtons) {
      commentButton.addEventListener('click', (e) => {
        e.preventDefault();
        openCommentsDrawer();
        if (!coralCommentsLoaded) {
          coralCommentsLoaded = true;
          initCoralComments();
        }
      });
    }

    let shouldReopenComments = false;
    try {
      shouldReopenComments =
        sessionStorage.getItem('coralReopenComments') === '1';
      if (shouldReopenComments)
        sessionStorage.removeItem('coralReopenComments');
    } catch {
      //
    }

    if (shouldReopenComments) {
      openCommentsDrawer();
      if (!coralCommentsLoaded) {
        coralCommentsLoaded = true;
        initCoralComments();
      }
    }

    import(/* webpackPrefetch: true */ '../common/utils/comments').then(
      (module) => {
        module.initComments(coralContainer, dataEdtn);
      },
    );
  }

  $('.photo-title a').on('click', function (e) {
    e.stopPropagation();
  });

  if (dataEdtn === 'de' || dataEdtn === 'ev_de') {
    const trendingWrapper = document.querySelector('.trending-content');
    const outbrainWrapper = document.querySelector('.outbrain_service');
    if (!!trendingWrapper && !!outbrainWrapper && window.innerWidth <= 1023) {
      const parentElement = outbrainWrapper.parentNode;
      parentElement.insertAdjacentElement('afterend', trendingWrapper);
    }
  }

  if (
    dataEdtn != 'de' &&
    dataEdtn != 'ev_de' &&
    !cpAuthhint &&
    device.type == 'desktop'
  ) {
    function setSidebarTopPosition() {
      const trendingWidget = document.querySelector('.trending-content');
      const scrollSidebar = document.querySelector(
        '.m1-newsfeed_sidebar-wrapper',
      );
      const bodyTag = document.querySelector('body');

      let trendingWidgetHeight;
      if (trendingWidget) {
        trendingWidgetHeight = trendingWidget.offsetHeight;
      }

      let headerHeight = 221;
      const contentBeforeHeight = 638;

      if (bodyTag.classList.contains('no-rect-strip')) {
        headerHeight = 83;
      }

      const paddingNum =
        trendingWidgetHeight + contentBeforeHeight - headerHeight;

      if (scrollSidebar) {
        scrollSidebar.style.top = `-${paddingNum}px`;
      }
    }

    let resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        setSidebarTopPosition();
      }, 300);
    });
    setSidebarTopPosition();
  }

  const trendingItems = $('.trending-content_item:visible');

  trendingItems.each((index, item) => {
    $(item)
      .find('.item-index')
      .text(index + 1);
  });

  function setAdfeedData() {
    const articleTag = document.querySelector('.adfeed-container');
    const articleTopicId = articleTag ? articleTag.dataset.topicId : null;

    const m1ItUrls =
      articleTopicId == '506'
        ? ['/more-news/insideevs/']
        : ['/more-news/insideevs/', '/more-news/omnifurgone/'];
    const evFrUrls =
      articleTopicId == '512' ? [null] : ['/more-news/insideevs/'];

    const adFeedConfigs = [
      {
        edtn: 'ra_us',
        urls: ['/more-news/motor1/', '/more-news/insideevs/'],
      },
      {
        edtn: 'us',
        urls: ['/more-news/insideevs/', '/more-news/rideapart/'],
      },
      {
        edtn: 'ev_us',
        urls: ['/more-news/motor1/', '/more-news/rideapart/'],
      },
      {
        edtn: 'it',
        urls: m1ItUrls,
      },
      {
        edtn: 'ev_it',
        urls: ['/more-news/motor1/', '/more-news/omnifurgone/'],
      },
      {
        edtn: 'ot',
        urls: ['/more-news/motor1/', '/more-news/insideevs/'],
      },
      {
        edtn: 'fr',
        urls: evFrUrls,
      },
      {
        edtn: 'es',
        urls: ['/more-news/motorsport/', '/more-news/motos/'],
      },
      {
        edtn: 'tr',
        urls: ['/more-news/motorsport/'],
      },
      {
        edtn: 'br',
        urls: ['/more-news/insideevs/', '/more-news/motos/'],
      },
      {
        edtn: 'ev_br',
        urls: ['/more-news/motor1/', '/more-news/motos/'],
      },
    ];

    const config = adFeedConfigs.find((cfg) => cfg.edtn === dataEdtn);

    if (!config) return;

    const intersectingTarget = document.querySelector('.adfeed-container');

    if (intersectingTarget) {
      const intersectingOptions = {
        rootMargin: '100px',
      };

      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('no-observe');
            observer.unobserve(intersectingTarget);
            const [url1, url2] = config.urls;
            getAdfeed(url1, url2, intersectingTarget);
          }
        }
      }, intersectingOptions);

      observer.observe(intersectingTarget);
    }
  }

  if (device.type == 'desktop') {
    let trendingItems = document.querySelectorAll('#article_box .related-item');
    for (let trendingItem of trendingItems) {
      let imgHeight =
        trendingItem.querySelector('.related-item-img').offsetHeight;
      let textHeight = trendingItem.querySelector(
        '.title-related-item',
      ).offsetHeight;
      // console.log(trendingItem, imgHeight, textHeight, textHeight/imgHeight);
      if (textHeight / imgHeight > 1.62) {
        trendingItem.parentElement.classList.add('oneline');
      }
    }
  }

  setAdfeedData();

  const preferredSourceButton = document.getElementById(
    'preferred-source-button',
  );
  if (preferredSourceButton) {
    import(
      /* webpackIgnore: true */ 'https://news.google.com/swg/js/v1/publisher.mjs'
    ).then(({ preferredSource }) => {
      preferredSource.init({});
      preferredSourceButton.addEventListener('click', () => {
        gtmDataLayer.push({
          event: 'googlePreferredSourcesButtonClicked',
          url: document.location.href,
        });
        preferredSource.addPreferredSource();
      });
    });
  }

  document.querySelectorAll('.infobox--subheadline').forEach((el) => {
    if (!el.textContent.trim()) {
      el.setAttribute('data-empty', 'true');
    }
  });

  const visited = getCookie('visited');
  if (!visited) {
    const initObserver = () => {
      const surveyWidget = document.querySelector('.m1-survey-promo');
      if (!surveyWidget) return false;

      surveyWidget.classList.add('hidden');

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
          ) {
            if (!surveyWidget.classList.contains('hidden')) {
              surveyWidget.classList.add('hidden');
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(surveyWidget, {
        attributes: true,
        attributeFilter: ['class'],
      });

      return true;
    };

    if (!initObserver()) {
      window.addEventListener('load', () => {
        initObserver();
      });
    }

    setCookie('visited', 1, 3650);
  }

  if (dataEdtn == 'it') {
    const recommendationStrip = document.getElementsByClassName('rec-strip')[0];
    import(/* webpackPrefetch: true */ '../common/froomle').then((module) => {
      console.log(module);
      // return;
      const froomleApi = module.getFroomleApi();
      console.log('MODULE', module);
      return froomleApi;
    });
  }
};
